import { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const {
    token,
    authLoading,
    sessionChecked,
    refreshSession,
  } = useContext(AuthContext);

  useEffect(() => {
    if (!sessionChecked && !authLoading) {
      void refreshSession();
    }
  }, [sessionChecked, authLoading, refreshSession]);

  if (!sessionChecked || authLoading) {
    return (
      <div className="route-loader" aria-live="polite" aria-busy="true">
        <span className="route-loader-text">Checking secure session...</span>
      </div>
    );
  }

  return token ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
